export default __webpack_public_path__ + "static/media/Howitworks1.d08928dd.png";